import React, { Component } from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PlaceholderJson from '../../Component/PlaceholderJson';
import GenerateToken from '../../Component/GenerateToken';
import { Grid, Box, Alert } from '@mui/material';
import config from '../../../config';

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasToken: this.props.hasToken,
    };
  }

  changeTokenStatus = status => {
    this.setState({ hasToken: status });
    this.props.changeTokenStatus(status);
  };

  render() {
    const { data } = this.props.componentStore;
    return (
      <Grid item xs={12} className="textAlignLeftWebhook">
        <Grid item xs={12}>
          <Alert
            severity="success"
            sx={{
              mb: 2,
              fontWeight: 'medium',
              '& .MuiAlert-icon': {
                alignItems: 'center',
              },
            }}
          >
            Set up has been completed for this Trigger from Zapier component
          </Alert>
          <Alert
            severity="info"
            sx={{
              mb: 2,
              fontWeight: 'medium',
              '& .MuiAlert-icon': {
                alignItems: 'center',
              },
            }}
          >
            You must publish this workflow before it can be triggered from Zapier
          </Alert>
          <Box sx={{ mb: 3 }}>
            <Box sx={{ mb: 1, fontWeight: 'medium' }}>Production Endpoint URL</Box>
            <TextField
              disabled={true}
              value={`${config.ZAPIER_ENDPOINT.PRODUCTION}/${this.props.component_id}`}
              variant="outlined"
              fullWidth
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  width: '100%',
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CopyToClipboard
                      text={`${config.ZAPIER_ENDPOINT.PRODUCTION}/${this.props.component_id}`}
                    >
                      <FileCopyIcon className="custom-icon-btn" />
                    </CopyToClipboard>
                  </InputAdornment>
                ),
              }}
            ></TextField>
          </Box>
          {
            <Grid item xs={12} className="generateWebhook">
              {!this.state.hasToken ? (
                <span
                  className="err-text"
                  style={{
                    justifyContent: 'flex-start',
                    fontWeight: 'bold',
                    margin: '16px 0',
                  }}
                >
                  <ErrorIcon className="iconDiscard" />A token must be generated before the Trigger
                  from Zapier component can be used.
                </span>
              ) : (
                <span
                  className="token-already-generated"
                  style={{
                    justifyContent: 'flex-start',
                    margin: '16px 0',
                  }}
                >
                  A token has already been generated. If you have lost this token, you will need to
                  generate a new one.
                </span>
              )}

              <GenerateToken
                isSingleLine={true}
                hasToken={status => {
                  this.changeTokenStatus(status);
                }}
                tokenStatus={this.props.hasToken}
                name={this.props.ComponentName}
                component_id={this.props.component_id}
              />
            </Grid>
          }
          <Grid item xs={12} className="webhook-title">
            <span>The following placeholders will be generated from the incoming data </span>
            <span
              onClick={() => this.props.onChangeState(4, 4)}
              style={{
                color: 'var(--color-text-primary)',
                fontWeight: 'normal',
                cursor: 'pointer',
              }}
            >
              edit placeholders
            </span>
          </Grid>
          <PlaceholderJson
            componentStore={this.props.componentStore}
            data={this.props.componentStore.data}
            stepStatus={this.props.stepStatus}
            placeholderJson={data.samplePlaceholders}
          />
        </Grid>
        <Grid item xs={12} className="dialogContentRight">
          <Grid item xs={12}>
            <Button
              onClick={() => {
                this.props.onChangeState(6, 6);
              }}
              className="btnSpace"
              variant={'outlined'}
              color={'info'}
            >
              {' '}
              Back
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default Summary;
